module.exports = __webpack_public_path__ + "static/media/_bhutan-1.f14bdee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_bhutan-1.svg
// module id = 2304
// module chunks = 7